export enum MovementType {
  None,
  Internal,
  External,
  All,
}
